var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$root.loading)?_c('div',{staticClass:"modal-parent"},[_c('div',{staticClass:"overlay-loader"},[_c('div',{staticClass:"cp-spinner cp-round"}),_vm._v(" "),_c('div',{staticClass:"message-block",domProps:{"textContent":_vm._s(_vm.__('shop.overlay-loader.message'))}})])]):_vm._e()}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7153083e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Resources/assets/js/UI/components/overlay-loader.vue
// module id = yQhS
// module chunks = 0